
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enrollment",
      function () {
        return require("private-next-pages/enrollment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enrollment"])
      });
    }
  